import { Component, OnInit } from '@angular/core';

import { ToastrService } from 'ngx-toastr';
import { unlockAccount } from '../../../models/account';
import { Router } from '@angular/router';
import { FormGroup, FormBuilder, Validators} from '@angular/forms';
import { AuthService } from '../../../shared/services/authentication/auth.service';
import { TokenStorageService } from '../../../shared/services/authentication/token-storage.service';

@Component({
  selector: 'app-unlock-user',
  templateUrl: './unlock-user.component.html',
  styleUrls: ['./unlock-user.component.scss']
})
export class UnlockUserComponent implements OnInit {
  public unlockForm: FormGroup;
  unlock = new unlockAccount();
  isLoggedIn = false;
  isLoginFailed = false;
  currentUser: any;
  errorMessage = '';
  roles: any[] = [];
  rolesName: string[] = [];

  constructor(private router: Router,
    private fb: FormBuilder,
    private authService: AuthService,
    private tokenStorage: TokenStorageService,
    private toastr: ToastrService) { 
      this.currentUser = this.tokenStorage.getUser();

      this.unlockForm = this.fb.group({
        password: ['', [Validators.required, Validators.minLength(8)]]
      });
    }

  ngOnInit() {
    this.isLoggedIn = true;
   }

  onKey(event: any) { // without type info
    this.isLoginFailed = false;
  }

  onUnlock(){
    this.unlock.password = this.unlockForm.value['password'];
    this.roles = this.tokenStorage.getUser().roles;

    console.log("ROLES: ", this.roles);
    this.authService.unlock(this.unlock).subscribe(
      data => {
        if(data.errors)
        {
          this.errorMessage = data.errors[0].message;
          this.isLoginFailed = true;
          this.toastr.error(this.errorMessage, 'Error !');
        }
        else
        {
          this.isLoggedIn = true;
          this.isLoginFailed = false;

          for(let i=0;i<this.roles.length;i++)
            this.rolesName[i]=this.roles[i].name

          this.toastr.success('Welcome back, '+ data.data.username +' our friend', 'Success !');

          if(this.rolesName.includes('ROLE_ADMIN'))
            this.router.navigate(['/adm/dashboard']);
            // this.router.navigate(['/dashboard/default']);
          else
            this.router.navigate(['/pub/dashboard']);
            // this.router.navigate(['/dashboard/default']);
        }
      },
      err => {
        this.errorMessage = err.error.errors[0].message;
        this.isLoginFailed = true;
        this.toastr.error(this.errorMessage, 'Error !');
      }
    );
  }
}
